export default "__VITE_ASSET__DmPFJ7Is__"